<template>
  <div>
    <div class="container-fluid">
      <div class="row row-eq-height">
        <div class="col-sm-6 grey-grad-bg center-content"><br>
          <div class="row">
            <div class="col-md-6 col-md-offset-3 text-center">
              <h1 class="text-uppercase">{{item.name}}</h1>
              <br>
              <div class="row">
                <div class="col-xs-8">
                  <input
                    type="text"
                    class="form-control client-form-control input-lg"
                    placeholder="Quantity" disabled>
                </div>
                <div class="col-xs-4">
                  <input
                    type="number"
                    class="form-control client-form-control input-lg"
                    placeholder=""
                    v-model="quantity"
                  >
                </div>
              </div>
              <div class="clearfix"></div>
              <br>
              <a
                href=""
                type="button"
                class="btn client-btn-primary btn-lg btn-block text-uppercase"
                @click.prevent="submit"
              >
                CONTINUE
              </a>
              <br>
              <a
                href=""
                type="button"
                class="btn client-btn-primary btn-lg btn-block text-uppercase"
                @click.prevent="goItemSearchResults"
              >
                <span class="glyphicon-chevron-left glyphicon"></span> Back
              </a>
              <br>
              <br>
            </div>
          </div>
        </div>

        <div class="col-sm-6 redeem-sec">
          <div class="row max-height">
            <div class="col-md-8 col-md-offset-2 text-center text-uppercase max-height">
              <div class="rebate-image-container max-height">
                <img :src="itemImage" class="">
                <p><span class="grey-type"><strong>{{ item.name }}</strong></span></p>
              </div>
            </div>
            <br>
            <br>
            <br>
          </div>
        </div>
      </div>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import DatePicker from 'vuejs-datepicker'
import S3 from '../../../_helpers/awsS3'
import Spinner from 'vue-simple-spinner'
import { mapGetters, mapState, mapActions } from 'vuex'
const crypto = require('crypto')

export default {
  name: 'ItemDetails',
  props: {
    invoiceData: {},
    item: {},
    filters: {}
  },
  components: {
    datepicker: DatePicker,
    spinner: Spinner
  },
  data () {
    return {
      file: null,
      loading: false,
      validFileTypes: [
        'image/png',
        'image/jpg',
        'image/jpeg',
        'application/pdf'
      ],
      quantity: 0
    }
  },
  computed: {
    ...mapGetters('loyaltyProgram', ['program']),
    ...mapState('auth', {
      userLoyaltyProgramId: state => state.user.userLoyaltyProgram._id
    }),
    category () {
      return this.program.categories.find(category => category.category === this.item.category) || {}
    },
    itemImage () {
      return this.item.image.url ? this.item.image.url
        : this.category.image ? this.category.image.url
          : ''
    }
  },
  methods: {
    ...mapActions('receipt', ['clientAddReceiptItem']),
    goItemSearchResults () {
      this.$bus.emit('swapComponent', { component: 'item-search-results', props: { filters: this.filters } })
    },
    submit () {
      let errors = this.validate()
      if (errors.length > 0) {
        errors.forEach((error, idx) => {
          setTimeout(() => this.$bus.emit('notify', { message: error, type: 'danger' }), 500 * idx)
        })
        return
      }
      let payload = {
        receiptData: { ...this.invoiceData, ...{ itemId: this.item._id, quantity: this.quantity } },
        userLoyaltyProgramId: this.userLoyaltyProgramId
      }
      this.$bus.emit('global-load', { load: true, message: 'Processing submission', env: 'client' })
      this.clientAddReceiptItem(payload)
        .then(response => {
          this.$bus.emit('global-load', { load: false })
          if (!this.invoiceData.receiptId) this.invoiceData.receiptId = response.receiptId
          this.invoiceData.items.push({ item: this.item, quantity: this.quantity })
          this.$bus.emit('swapComponent', { component: 'item-confirmation', props: { item: this.item } })
        })
        .catch(error => {
          this.$bus.emit('global-load', { load: false })
          let message = 'Submission error, please try again.'
          if (error.response.data.type) {
            message += this.getErrorMessage(error.response.data.type)
          }
          this.$bus.emit('notify', { message, type: 'danger', time: 10000 })
          // console.log(error)
        })
    },
    getErrorMessage (errorType) {
      if (errorType === 'receipt-item-exists') return '\nThis Item has already been submitted.'
      else if (errorType === 'receipt-exists') return '\nThis Submission/Transaction has already been submitted.'
      else if (errorType === 'receipt-approved') return '\nThis Submission/Transaction has already been submitted and approved.'
      else if (errorType === 'receipt-submitted') return '\nThis Submission/Transaction has already been submitted.'
      return ''
    },
    validate () {
      let errors = []
      if (!this.invoiceData.dateOfPurchase) errors.push('Transaction date required.')
      if (!this.invoiceData.receiptNumber) {
        errors.push('Invoice/Receipt number is required')
      } else {
        if (isNaN(this.invoiceData.receiptNumber)) errors.push('Invoice/Receipt number must be a number')
      }
      if (!this.quantity) {
        errors.push('Quantity is required')
      } else {
        if (this.quantity < 1) errors.push('Quantity must be greater than 0')
      }
      return errors
    }
  }
}
</script>

<style scoped>
.center-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.rebate-image-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.rebate-image-container img {
  max-width: 100%;
  height: 60vh;
}

.max-height {
  height: 100%;
}

.choose-color {
  background-color:  #FFF;
  padding: 15px;
  color: #464646;
  margin-bottom: 15px;
}

.grey-grad-bg .vdp-datepicker {
  color: initial;
}
</style>
